module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/advertisement/advertisement.component.css
// module id = 966
// module chunks = 1